export const FACTORY_ADDRESSES = {
  74: '0x6A662F91E14312a11a2E35b359427AEf798fD928',
  39: '0x5a6BB37E97dB359840c6A89AFBE0B09674b74e92',
}

export const SUPPORTED_THEMES = {
  DARK: 'DARK',
  LIGHT: 'LIGHT'
}
